module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp3-03-1802f07bf3eb68382dfb11cd09c484b9.png";